export const currencies = [
    "US DOLLAR",
    "STG POUND",
    "EURO",
    "SA RAND",
    "KES / USHS",
    "KES / TSHS",
    "KES / RWF",
    "KES / BIF",
    "AE DIRHAM",
    "CAN $",
    "S FRANC",
    "JPY (100)",
    "SW KRONER",
    "NOR KRONER",
    "DAN KRONER",
    "IND RUPEE",
    "HONGKONG DOLLAR",
    "SINGAPORE DOLLAR",
    "SAUDI RIYAL",
    "CHINESE YUAN",
    "AUSTRALIAN $"
]